export default __webpack_public_path__ + "static/media/i061jk.0f2c9cdc.webp";